export const getCPTData = (testType) => {
  console.log(testType);
  if (testType === "DEMO" || testType === "CALIBRATION") {
    return [
      {
        letter: "A",
        id: 1,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
        test_format:"tap_letter"
      },
      {
        letter: "V",
        id: 2,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
        test_format:"tap_letter"
      },
      {
        letter: "X",
        id: 3,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
        test_format:"tap_letter"
      },
      {
        letter: "B",
        id: 4,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
        test_format:"tap_letter"
      },
      {
        letter: "N",
        id: 5,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
        test_format:"tap_letter"
      },
      {
        letter: "M",
        id: 6,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
        test_format:"tap_letter"
      },
      {
        letter: "Z",
        id: 7,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
        test_format:"tap_letter"
      },
      {
        letter: "X",
        id: 8,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
        test_format:"tap_letter"
      },
      {
        letter: "C",
        id: 9,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
        test_format:"tap_letter"
      },
      {
        letter: "S",
        id: 10,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
        test_format:"tap_letter"
      },
      {
        letter: "D",
        id: 11,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
        test_format:"tap_letter"
      },
    ];
  } else {
    return [
      {
        letter: "A",
        id: 1,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "V",
        id: 2,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 3,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "B",
        id: 4,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "N",
        id: 5,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "M",
        id: 6,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "Z",
        id: 7,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 8,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "C",
        id: 9,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "S",
        id: 10,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "D",
        id: 11,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 12,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "F",
        id: 13,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "G",
        id: 14,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "H",
        id: 15,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "J",
        id: 16,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 17,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "K",
        id: 18,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "L",
        id: 19,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "Q",
        id: 20,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "W",
        id: 21,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "E",
        id: 22,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 23,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "R",
        id: 24,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "T",
        id: 25,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "Y",
        id: 26,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 27,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "U",
        id: 28,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "I",
        id: 29,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "O",
        id: 30,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 31,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "P",
        id: 32,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "Z",
        id: 33,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "C",
        id: 34,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "V",
        id: 35,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "B",
        id: 36,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "N",
        id: 37,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "M",
        id: 38,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 39,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "A",
        id: 40,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "S",
        id: 41,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 42,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "D",
        id: 43,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "F",
        id: 44,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "G",
        id: 45,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "H",
        id: 46,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 47,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "J",
        id: 48,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "K",
        id: 49,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "L",
        id: 50,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "Q",
        id: 51,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "W",
        id: 52,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 53,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "E",
        id: 54,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "R",
        id: 55,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "T",
        id: 56,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "Y",
        id: 57,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 58,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "U",
        id: 59,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "I",
        id: 60,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "O",
        id: 61,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 62,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "P",
        id: 63,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "Z",
        id: 64,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "C",
        id: 65,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "V",
        id: 66,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 67,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "B",
        id: 68,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "N",
        id: 69,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "M",
        id: 70,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "A",
        id: 71,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "S",
        id: 72,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 73,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "D",
        id: 74,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "F",
        id: 75,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "G",
        id: 76,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 77,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "H",
        id: 78,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "J",
        id: 79,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "K",
        id: 80,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 81,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "L",
        id: 82,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "Q",
        id: 83,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "W",
        id: 84,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "E",
        id: 85,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "R",
        id: 86,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "T",
        id: 87,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "Y",
        id: 88,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 89,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "U",
        id: 90,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "I",
        id: 91,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 92,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "O",
        id: 93,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "P",
        id: 94,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "A",
        id: 95,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "S",
        id: 96,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "X",
        id: 97,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "D",
        id: 98,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "F",
        id: 99,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
      {
        letter: "G",
        id: 100,
        score_count: "single",
        difficulty_level: 1,
        section_name: "CONTINUOUS PERFORMANCE",
      },
    ];
  }
};
